import { gql } from '@apollo/client';

export const VALIDATE_MITARBEITER_EMAIL = gql`
  query mitarbeiter_validateMitarbeiterEmail($email: String!) {
    Anlageassistent_validateEmail(email: $email) {
      findings {
        __typename
      }
    }
  }
`;
